import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconThumbsUp24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 11.5H6A1.5 1.5 0 0 0 4.5 13v4A1.5 1.5 0 0 0 6 18.5h1zm1.5 7h7.226a1.5 1.5 0 0 0 1.315-.777l2.2-4a1.5 1.5 0 0 0-1.315-2.223h-5.124l.21-1.685.532-4.274-4.93 5.464-.114.126zm6.532-12.773L14.687 8.5 14.5 10h3.426c2.282 0 3.729 2.447 2.629 4.446l-2.2 4A3 3 0 0 1 15.726 20H6a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.5l4.93-5.464c.983-1.089 2.784-.265 2.602 1.19"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp24);
